export const projects = {
  hero: {
    title: 'Nos projets et programmes',
    subtitle: 'Découvrez comment nous faisons une différence tangible grâce à des programmes ciblés en aide d\'urgence, soins de santé, éducation, sécurité alimentaire et abris pour les réfugiés et les communautés vulnérables à travers la RDC.',
  },
  categories: {
    all: 'Tous les projets',
    food: 'Alimentation',
    healthcare: 'Santé',
    shelter: 'Abri',
    education: 'Éducation',
  },
  urgency: {
    critical: '🔴 Besoin critique',
    high: '🟠 Haute priorité',
    medium: '🟡 Besoin continu',
    low: '✅ Objectif atteint',
  },
  status: {
    active: 'Actif',
    completed: 'Terminé',
  },
  card: {
    raised: 'Collecté',
    goal: 'Objectif',
    funded: 'financé',
    supportButton: 'Soutenir ce projet',
    completedButton: 'Projet terminé',
  },
  cta: {
    title: 'Chaque contribution compte',
    subtitle: 'Que ce soit 10 $ ou 10 000 $ — votre soutien atteint directement les familles dans le besoin à travers la RDC. Choisissez n\'importe quel projet ci-dessus ou faites un don général.',
    donateButton: 'Faire un don',
  },
   contact: {
     // Page Header
     title: 'Contactez-nous',
     subtitle: 'Nous sommes là pour vous aider et répondre à toutes vos questions. Que vous soyez un donateur, un partenaire, un bénévole ou simplement une personne souhaitant en savoir plus sur notre travail—nous aimerions avoir de vos nouvelles.',
     responseTime: 'Nous répondons généralement dans les 24 heures.',
     headerCta: {
       becomePartner: 'Devenir Partenaire',
       supportMission: 'Soutenir Notre Mission',
     },

     // Contact Info Cards
     email: {
       title: 'Adresse e-mail',
       address: 'info@handsofhope.org',
     },
     phone: {
       title: 'Numéro de téléphone',
       number: '+256773515447',
     },
     location: {
       title: 'Adresse du Bureau',
       address: 'Goma, Nord-Kivu\nRépublique démocratique du Congo',
     },
     workingHours: {
       title: 'Heures de Travail',
       weekdays: 'Lundi - Vendredi',
       time: '8h00 - 18h00',
       weekend: 'Samedi',
       weekendTime: '9h00 - 14h00',
       timezone: 'Heure d\'Afrique Centrale (CAT)',
     },

     // Social Media
     social: {
       title: 'Suivez-nous',
       followOn: 'Suivez-nous sur',
     },

     // Quick Support Section
     quickSupport: {
       title: 'Besoin d\'Assistance Urgente ?',
       description: 'Si vous avez besoin d\'une assistance immédiate ou une demande urgente, contactez-nous directement:',
       callNow: 'Appelez Maintenant',
       emailNow: 'Envoyez un e-mail',
       tollFree: 'Ligne Verte',
       hotlineNumber: '+256 800 123 456',
     },

     // Contact Form
     form: {
       title: 'Envoyez-nous un Message',
       name: 'Nom Complet',
       email: 'Adresse e-mail',
       phone: {
         label: 'Numéro de Téléphone (Facultatif)',
         placeholder: '+1234567890',
       },
       subject: 'Sujet',
       subjectPlaceholder: 'Sélectionnez un sujet',
       subjectOptions: {
         general: 'Demande Générale',
         donation: 'Dons & Soutien Financier',
         volunteer: 'Opportunités de Bénévolat',
         partnership: 'Partenariat & Collaboration',
         media: 'Médias & Presse',
         other: 'Autre',
       },
       message: 'Votre Message',
       messagePlaceholder: 'Dites-nous comment nous pouvons vous aider...',
       phoneNumberLabel: 'Numéro de téléphone',
       charactersLimit: 'caractères',
       submitButton: 'Envoyer le Message',
       submitting: 'Envoi en cours...',
       successMessage: 'Merci de nous avoir contactés ! Nous avons reçu votre message et vous répondrons dans les 24 heures.',
       errorMessage: 'Quelque chose s\'est mal passé. Veuillez réessayer.',
     },

     // FAQ Section
     faq: {
       title: 'Questions Fréquemment Posées',
       items: [
         {
           question: 'Dans quel délai recevrai-je une réponse ?',
           answer: 'Nous nous efforçons de répondre à toutes les demandes dans les 24 heures pendant les jours ouvrables. Pour les urgences, veuillez utiliser notre ligne d\'assistance rapide.',
         },
         {
           question: 'Comment puis-je devenir bénévole chez Hands of Hope ?',
           answer: 'Visitez notre page "S\'engager" pour explorer les opportunités de bénévolat, ou sélectionnez "Opportunités de Bénévolat" dans le formulaire de contact et nous vous guiderons à travers le processus.',
         },
         {
           question: 'Quels types de dons acceptez-vous ?',
           answer: 'Nous acceptons les dons monétaires uniques et récurrents, les contributions en nature et les partenariats d\'entreprise. Contactez notre équipe des relations avec les donateurs pour plus d\'informations.',
         },
         {
           question: 'Comment puis-je devenir partenaire de votre organisation ?',
           answer: 'Nous accueillons des partenariats avec des entreprises, des ONG et des organisations communautaires. Sélectionnez "Partenariat" dans le formulaire ou envoyez-nous un e-mail à partnerships@handsofhope.org.',
         },
       ],
     },

     // Map & Footer CTAs
     map: {
       title: 'Notre Localisation',
       getDirections: 'Itinéraire',
     },
     cta: {
       partnerTitle: 'Devenez Partenaire',
       partnerDesc: 'Rejoignez-nous pour créer un changement durable en devenant un partenaire stratégique.',
       donateTitle: 'Soutenez Notre Mission',
       donateDesc: 'Votre contribution, petite ou grande, a un impact direct sur des vies à travers la RDC.',
       donateButton: 'Faire un Don',
       partnerButton: 'En Savoir Plus',
     },
   },
};
